/**
 * Nome da flag da Rede Comercial — só constante.
 *
 * Arquivo à parte, sem React nem rede, porque `shared/nav-items.ts` precisa do
 * nome da flag mestre e é importado por módulos e testes puros (mesmo molde de
 * `clube/clube-flags.ts`). A flag nasce DESLIGADA na tabela `feature_flag`.
 */

/** Mestre: desligada, todo `/v1/rede/*` responde 404 (W12). */
export const FLAG_REDE_MESTRE = 'rede.habilitada'
